import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function System() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Title */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-3">
              System
            </h1>
            <p className="text-pink-500 text-xl">料金システム</p>
          </div>

          {/* Membership Fee */}
          <section className="mb-16">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 md:p-12">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-vip-crown-line text-pink-500 mr-3"></i>
                入会手数料
              </h2>
              <div className="bg-white rounded-xl p-6">
                <div className="flex items-center justify-between">
                  <span className="text-lg text-gray-700">初回登録料</span>
                  <span className="text-3xl font-bold text-pink-500">無料</span>
                </div>
              </div>
            </div>
          </section>

          {/* Course Pricing */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
              <i className="ri-time-line text-pink-500 mr-3"></i>
              コース料金
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white border-2 border-pink-200 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="text-center">
                  <div className="text-5xl font-bold text-pink-500 mb-2">40</div>
                  <div className="text-gray-600 mb-6">分コース</div>
                  <div className="text-4xl font-bold text-gray-800 mb-4">¥10,000</div>
                  <p className="text-sm text-gray-500">手軽に癒されたい方に</p>
                </div>
              </div>

              <div className="bg-white border-2 border-pink-200 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="text-center">
                  <div className="text-5xl font-bold text-pink-500 mb-2">70</div>
                  <div className="text-gray-600 mb-6">分コース</div>
                  <div className="text-4xl font-bold text-gray-800 mb-4">¥14,000</div>
                  <p className="text-sm text-gray-500">じっくり癒されたい方に</p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-pink-100 to-purple-100 border-2 border-pink-300 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300 relative">
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <span className="bg-pink-500 text-white text-xs px-4 py-1 rounded-full font-semibold">
                    人気No.1
                  </span>
                </div>
                <div className="text-center">
                  <div className="text-5xl font-bold text-pink-600 mb-2">90</div>
                  <div className="text-gray-700 mb-6">分コース</div>
                  <div className="text-4xl font-bold text-gray-800 mb-4">¥17,000</div>
                  <p className="text-sm text-gray-600">一番人気のコース</p>
                </div>
              </div>

              <div className="bg-white border-2 border-pink-200 rounded-2xl p-8 hover:shadow-xl transition-shadow duration-300">
                <div className="text-center">
                  <div className="text-5xl font-bold text-pink-500 mb-2">110</div>
                  <div className="text-gray-600 mb-6">分コース</div>
                  <div className="text-4xl font-bold text-gray-800 mb-4">¥20,000</div>
                  <p className="text-sm text-gray-500">たっぷり癒しの時間</p>
                </div>
              </div>
            </div>
          </section>

          {/* Nomination Fee */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
              <i className="ri-star-line text-pink-500 mr-3"></i>
              指名料
            </h2>
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6">
                  <div className="flex items-center justify-between">
                    <span className="text-lg text-gray-700">本指名</span>
                    <span className="text-2xl font-bold text-pink-500">¥2,000</span>
                  </div>
                </div>
                <div className="bg-white rounded-xl p-6">
                  <div className="flex items-center justify-between">
                    <span className="text-lg text-gray-700">フリー</span>
                    <span className="text-2xl font-bold text-pink-500">無料</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Options */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
              <i className="ri-add-circle-line text-pink-500 mr-3"></i>
              オプション
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white border border-pink-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <span className="text-lg text-gray-700">オプション A</span>
                  <span className="text-xl font-bold text-pink-500">¥3,000</span>
                </div>
              </div>
              <div className="bg-white border border-pink-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <span className="text-lg text-gray-700">オプション B</span>
                  <span className="text-xl font-bold text-pink-500">¥5,000</span>
                </div>
              </div>
              <div className="bg-white border border-pink-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <span className="text-lg text-gray-700">オプション C</span>
                  <span className="text-xl font-bold text-pink-500">¥4,000</span>
                </div>
              </div>
              <div className="bg-white border border-pink-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center justify-between">
                  <span className="text-lg text-gray-700">オプション D</span>
                  <span className="text-xl font-bold text-pink-500">¥6,000</span>
                </div>
              </div>
            </div>
          </section>

          {/* Extension */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
              <i className="ri-timer-line text-pink-500 mr-3"></i>
              延長料金
            </h2>
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6">
                  <div className="flex items-center justify-between">
                    <span className="text-lg text-gray-700">30分延長</span>
                    <span className="text-2xl font-bold text-pink-500">¥7,000</span>
                  </div>
                </div>
                <div className="bg-white rounded-xl p-6">
                  <div className="flex items-center justify-between">
                    <span className="text-lg text-gray-700">60分延長</span>
                    <span className="text-2xl font-bold text-pink-500">¥13,000</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Area & Transportation */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
              <i className="ri-map-pin-line text-pink-500 mr-3"></i>
              出張エリア・交通費
            </h2>
            <div className="bg-white border-2 border-pink-200 rounded-2xl p-8">
              <div className="space-y-4">
                <div className="flex items-center justify-between pb-4 border-b border-pink-100">
                  <span className="text-lg text-gray-700">都内主要エリア</span>
                  <span className="text-xl font-bold text-pink-500">コース料金に含む</span>
                </div>
                <div className="flex items-center justify-between pb-4 border-b border-pink-100">
                  <span className="text-lg text-gray-700">都内その他エリア</span>
                  <span className="text-xl font-bold text-pink-500">+¥2,000</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-lg text-gray-700">都外エリア</span>
                  <span className="text-xl font-bold text-pink-500">要相談</span>
                </div>
              </div>
            </div>
          </section>

          {/* Payment Methods */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-8 flex items-center">
              <i className="ri-bank-card-line text-pink-500 mr-3"></i>
              お支払い方法
            </h2>
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8">
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white rounded-xl p-6 text-center">
                  <i className="ri-money-dollar-circle-line text-4xl text-pink-500 mb-3"></i>
                  <p className="text-gray-700 font-semibold">現金</p>
                </div>
                <div className="bg-white rounded-xl p-6 text-center">
                  <i className="ri-bank-card-2-line text-4xl text-pink-500 mb-3"></i>
                  <p className="text-gray-700 font-semibold">クレジットカード</p>
                </div>
                <div className="bg-white rounded-xl p-6 text-center">
                  <i className="ri-smartphone-line text-4xl text-pink-500 mb-3"></i>
                  <p className="text-gray-700 font-semibold">電子決済</p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="text-center">
            <a
              href="https://r.caskan.jp/jdspa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-12 py-5 bg-gradient-to-r from-pink-500 to-pink-400 text-white text-lg rounded-full font-semibold hover:shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-check-line mr-3 text-2xl"></i>
              WEB予約はこちら
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}